import { render, staticRenderFns } from "./ComparatorMenu.vue?vue&type=template&id=06fcd6be&scoped=true"
import script from "./ComparatorMenu.vue?vue&type=script&lang=ts"
export * from "./ComparatorMenu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06fcd6be",
  null
  
)

export default component.exports